import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { SubMenuModel, SubMenuPropsModel } from '../../../../models/sidebarModel';

const SubMenu = ({
  menuId,
  menuData,
  handleSubMenuClick,
  subMenuId,
  isSidebarHovered
}: SubMenuPropsModel) => {
  const localData = localStorage.getItem('userData');
  const userData = localData ? JSON.parse(localData) : null;
  const userRole = userData?.role;

  // Filter submenu items for Video Creator role when menu is "Users" (id: 6)
  const filteredSubMenu =
    menuData.id === 6 && userRole === 'Video Creator'
      ? menuData.subMenu.filter((subMenu: SubMenuModel) => subMenu.route !== 'users/user-listing')
      : menuData.subMenu;

  return (
    <ul
      id="nav-menu"
      className={`custom-dropdown ${
        menuId === menuData.id && isSidebarHovered ? 'show' : ''
      } space-y-2`}>
      {filteredSubMenu.length !== 0 &&
        filteredSubMenu.map((subMenu: SubMenuModel, index: number) => {
          return (
            <li key={index} className="sub-menu-li">
              <Link
                to={`${subMenu.route}`}
                className={`inner-menus ${subMenuId === subMenu.id ? 'active' : ''}`}
                onClick={() => handleSubMenuClick(subMenu.id)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-2.5 h-2.5 mr-2"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentcolor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
                {subMenu.name}
                {/* BETA Label */}
                {/* {subMenu.name === 'Collections' && (
                  <span
                    className={`ml-auto px-2 py-1 text-xs font-semibold rounded ${
                      subMenuId === subMenu.id
                        ? 'bg-white text-purple-600'
                        : 'bg-purple-600 text-white'
                    }`}>
                    BETA
                  </span>
                )} */}
              </Link>
            </li>
          );
        })}
    </ul>
  );
};

export default memo(SubMenu);
